import MuiErrorIcon from '@material-ui/icons/Error';
import styled from 'styled-components';

export const ErrorIcon = styled(MuiErrorIcon)`
  color: ${({ theme }) => theme.colors.darkRed};
`;
